import React from "react";
import "./Spinner.scss";

export default function Spinner() {
  return (
    <div className="Spinner absolute w-full h-full flex justify-center items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 100 100"
      >
        <g>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m53.333 30c0 1.833-1.5 3.333-3.333 3.333-1.833 0-3.333-1.501-3.333-3.333v-16.667c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m53.333 86.667c0 1.832-1.5 3.333-3.333 3.333-1.833 0-3.333-1.501-3.333-3.333v-16.667c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m30 46.667c1.833 0 3.333 1.5 3.333 3.333 0 1.833-1.5 3.333-3.333 3.333h-16.667c-1.832 0-3.333-1.5-3.333-3.333 0-1.833 1.501-3.333 3.333-3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m86.667 46.667c1.832 0 3.333 1.5 3.333 3.333 0 1.833-1.501 3.333-3.333 3.333h-16.667c-1.833 0-3.333-1.5-3.333-3.333 0-1.833 1.5-3.333 3.333-3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m33.503 61.784c1.295-1.296 3.418-1.296 4.713 0 1.296 1.295 1.296 3.418 0 4.713l-11.783 11.787c-1.296 1.296-3.418 1.296-4.714 0-1.296-1.295-1.296-3.418 0-4.713z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m73.571 21.715c1.295-1.295 3.418-1.295 4.713 0 1.296 1.296 1.296 3.418 0 4.714l-11.783 11.787c-1.296 1.295-3.418 1.295-4.714 0-1.296-1.296-1.296-3.418 0-4.714z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m61.784 66.497c-1.296-1.295-1.296-3.418 0-4.713 1.295-1.296 3.418-1.296 4.713 0l11.787 11.787c1.296 1.295 1.296 3.418 0 4.713-1.295 1.296-3.418 1.296-4.713 0z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m21.716 26.429c-1.296-1.296-1.296-3.418 0-4.714 1.295-1.295 3.418-1.295 4.713 0l11.787 11.785c1.296 1.295 1.296 3.418 0 4.713-1.295 1.295-3.418 1.295-4.713 0z"
            fill="#000000"
            data-original="#000000"
          ></path>
        </g>
        <g>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m53.333 30c0 1.833-1.5 3.333-3.333 3.333-1.833 0-3.333-1.501-3.333-3.333v-16.667c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m53.333 86.667c0 1.832-1.5 3.333-3.333 3.333-1.833 0-3.333-1.501-3.333-3.333v-16.667c0-1.833 1.5-3.333 3.333-3.333 1.833 0 3.333 1.5 3.333 3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m30 46.667c1.833 0 3.333 1.5 3.333 3.333 0 1.833-1.5 3.333-3.333 3.333h-16.667c-1.832 0-3.333-1.5-3.333-3.333 0-1.833 1.501-3.333 3.333-3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m86.667 46.667c1.832 0 3.333 1.5 3.333 3.333 0 1.833-1.501 3.333-3.333 3.333h-16.667c-1.833 0-3.333-1.5-3.333-3.333 0-1.833 1.5-3.333 3.333-3.333z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m33.503 61.784c1.295-1.296 3.418-1.296 4.713 0 1.296 1.295 1.296 3.418 0 4.713l-11.783 11.787c-1.296 1.296-3.418 1.296-4.714 0-1.296-1.295-1.296-3.418 0-4.713z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m73.571 21.715c1.295-1.295 3.418-1.295 4.713 0 1.296 1.296 1.296 3.418 0 4.714l-11.783 11.787c-1.296 1.295-3.418 1.295-4.714 0-1.296-1.296-1.296-3.418 0-4.714z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m61.784 66.497c-1.296-1.295-1.296-3.418 0-4.713 1.295-1.296 3.418-1.296 4.713 0l11.787 11.787c1.296 1.295 1.296 3.418 0 4.713-1.295 1.296-3.418 1.296-4.713 0z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m21.716 26.429c-1.296-1.296-1.296-3.418 0-4.714 1.295-1.295 3.418-1.295 4.713 0l11.787 11.785c1.296 1.295 1.296 3.418 0 4.713-1.295 1.295-3.418 1.295-4.713 0z"
            fill="#000000"
            data-original="#000000"
          ></path>
        </g>
      </svg>
    </div>
  );
}
